import { render, staticRenderFns } from "./DepartmentRoleUser.vue?vue&type=template&id=76856abc&"
import script from "./DepartmentRoleUser.vue?vue&type=script&lang=js&"
export * from "./DepartmentRoleUser.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentRoleUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports